import dataStore from 'exports-loader?dataStore!libwtgserver/storageutil';

/* TODO: this is to be replaced with something more sensible than calling sick
 * and ugly `storageutil.js` stuff, but for now it's just a thin layer in
 * between */
angular.module('WTG.PERSISTENCE',[]).factory('PERSISTENCE',function() {

 var DS = new dataStore();
 DS.initialize();

 var PERSISTENCE = {
  put1: function persistence_put1(key,data) {
   if(data===undefined) data = null;
   DS.storeLocalData(key,JSON.stringify(data));
  },
  get1: function persistence_get1(key,dflt) {
   var rv = DS.getLocalData(key,undefined);
   if(rv===undefined) return dflt;
   return JSON.parse(rv);
  },
  has1: function persistence_has1(key) {
   return DS.getLocalData(key,undefined)!==undefined;
  },

  put: function persistence_put(key,data) {
   var that = this;
   if(angular.isArray(key)) {
    key.forEach(function(x) { that.put(x.key,x.data) });
   }else if(angular.isObject(key)) {
    for(var k in key) that.put(k,key[k]);
   }else{
    that.put1(key,data);
   }
   return this;
  },
  get: function persistence_get(key,dflt) {
   var that = this;
   if(angular.isArray(key))
    throw new Error("I will implement this later, but don't yet know which way, so you should not be using array persistence get for now");
   if(angular.isObject(key))
    return Object.keys(key).reduce(function(p,c) {
     p[c] = that.get(c,key[c]);
     return p;
    },{});
   return this.get1(key,dflt);
  },
  has: function persistence_has(key) {
   return this.has1(key);
  },
  reset: function persistence_reset() {
   DS.clear();
   return this;
  },
  namespace: function persistence_namespace(ns) {
   function k(key) {
    return ns+'.'+key;
   }
   var rv = {
    parent: this,
    root: this.root,
    put1: function namespaced_put1(key,data) { return this.parent.put1(k(key),data) },
    get1: function namespaced_get1(key,dflt) { return this.parent.get1(k(key),dflt) },
    has1: function namespaced_has1(key) { return this.parent.has1(k(key)) }
   };
   return Object.assign(rv,{
    put: this.put.bind(rv),
    get: this.get.bind(rv),
    has: this.has.bind(rv),
    namespace: this.namespace.bind(rv),
    reset: function namespaced_reset() {
     throw new Error("not implemented");
    }
   });
  }
 };
 PERSISTENCE.root = PERSISTENCE;

 var app_namespace = window.location.pathname.replace(/^\/+/,'').replace(/\/+$/,'').replace(/\W+/g,'_');

 return PERSISTENCE.namespace(app_namespace);
});
